'use client';
import { icp } from '@/data/data';
import ICPAreaCard from '../common/icp-area-card';

const ICP = () => {
    return (
        <section className="desilo-service5-section section-padding-top overflow-hidden">
            <div className="container custom-container">
                <div className="row">
                    <div className="col-12">
                        <h2 className="title desilo__header">The people we build for</h2>
                    </div>
                </div>
                <div className="row gx-4 gy-5 row-padding-top">
                    {/* service card start */}
                    {icp.map((item, i) => (
                        <div key={i} className="col-md-6 col-lg-3">
                            <ICPAreaCard data={item} />
                        </div>
                    ))}
                    {/* service card end */}
                </div>
            </div>
        </section>
    );
};

export default ICP;
